import OppslagsverkPage from './OppslagsverkPage';

globalThis.Oppslagsverk = {
  OppslagsverkPage,
};
